import React, { useState, useEffect } from "react";
import { Card, Button, Alert, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get("token");
    if (!t) {
      setError("Missing or invalid token.");
    } else {
      setToken(t);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("❌ Passwords do not match.");
      return;
    }

    try {
      const response = await fetch("/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      if (response.ok) {
        setSubmitted(true);
        setTimeout(() => navigate("/login"), 5000);
      } else {
        const data = await response.json();
        setError(data.detail || "Something went wrong");
      }
    } catch (err) {
      setError("Network error");
    }
  };

  return (<>
  
        <Helmet>
        <title>Reset Your Password | IndexBooster</title>
        <meta name="description" content="Forgot password? Enter your email to receive a secure reset link and regain access to your account. No downtime - stay indexed!" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Reset Your Password | IndexBooster" />
        <meta property="og:description" content="Forgot password? Enter your email to receive a secure reset link and regain access to your account. No downtime - stay indexed!" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Reset Your Password | IndexBooster" />
        <meta name="twitter:description" content="Forgot password? Enter your email to receive a secure reset link and regain access to your account. No downtime - stay indexed!" />
      </Helmet>
  
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Card style={{ width: "400px", padding: "20px" }}>
        <Card.Body>
          <h2 className="text-center mb-4">Reset your password</h2>
          {submitted ? (
            <Alert variant="success">
              ✅ Your password has been updated. Redirecting to login...
            </Alert>
          ) : (
            <>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>New password</Form.Label>
                  <Form.Control
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Confirm new password</Form.Label>
                  <Form.Control
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button type="submit" variant="primary" className="w-100 mt-2">
                  Reset Password
                </Button>
              </Form>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
 </> );
};

export default ResetPassword;
